import { openDB } from 'idb';
import { uploadImage } from './imageUpload';
import { uploadDocument } from './docUpload';
import { v4 as uuidv4 } from 'uuid';
import { createSuccessToast } from './createToast';
import { removePendingToast, createPendingToast, removeErrorToasts } from './createOutboxToast';

//
// DATABASE (OUTBOX)
//
const dbPromise = openDB('upload-db', 1, {
  upgrade(db) {
    if (!db.objectStoreNames.contains('outbox')) {
      db.createObjectStore('outbox', { keyPath: 'id' });
    }
  },
});

const outbox = {
  add: async item => {
    const db = await dbPromise;
    await db.put('outbox', item);
  },

  remove: async id => {
    const db = await dbPromise;
    await db.delete('outbox', id);
  },

  getAll: async () => {
    const db = await dbPromise;
    return db.getAll('outbox');
  },
  count: async () => {
    const db = await dbPromise;
    return db.count('outbox');
  },
};
const saveToOutbox = async ({ file, filePath, empresaId, type = 'photo' }) => {
  await outbox.add({
    id: uuidv4(),
    file,
    filePath,
    empresaId,
    type,
    retries: 0,
    createdAt: Date.now(),
    status: 'pending',
  });
};
let isProcessing = false;

const processOutbox = async (cookie, setToastList) => {
  if (isProcessing) return;
  if (!navigator.onLine) return;

  const total = await outbox.count();

  if (!total) {
    removePendingToast(setToastList);
    return;
  }

  createPendingToast(setToastList, 'Enviando arquivos em segundo plano…');
  isProcessing = true;

  try {
    const db = await dbPromise;
    const items = await db.getAll('outbox'); // já usa direto

    for (const item of items) {
      const now = Date.now();

      if (item.nextRetryAt && now < item.nextRetryAt) {
        continue;
      }

      try {
        item.status = 'uploading';
        await db.put('outbox', item);

        if (item.type === 'document') {
          await uploadDocument({
            file: item.file,
            filePath: item.filePath,
            token: cookie?.authToken,
          });
        } else {
          await uploadImage({
            file: item.file,
            filePath: item.filePath,
            token: cookie?.authToken,
          });
        }

        await db.delete('outbox', item.id);
        removeErrorToasts(setToastList);
        const successMsg =
          item.type === 'document' ? 'Documento enviado com sucesso.' : 'Foto do chamado enviada com sucesso.';
        createSuccessToast(setToastList, successMsg);
      } catch (err) {
        console.error('Erro ao reprocessar upload', err);

        item.retries = (item.retries || 0) + 1;

        const delayMs = Math.min(1000 * 2 ** item.retries, 60000);

        item.nextRetryAt = Date.now() + delayMs;
        item.status = 'pending';

        await db.put('outbox', item);
      }
    }
  } finally {
    isProcessing = false;
    const remaining = await outbox.count();

    if (remaining === 0) {
      removePendingToast(setToastList);
    }
  }
};

export { saveToOutbox, processOutbox };
